import React, { useEffect, useState } from "react";
import { FaShoppingBag } from "react-icons/fa";
import axios from "axios";
import OrderDetails from "./orderDetails"; // Import OrderDetails modal component
import Modal from "react-modal";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const AllOrders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(true); // Loading state
  const token = localStorage.getItem("STITCHD_ID");

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true); // Set loading state to true
      try {
        if (token) {
          const response = await axios.get(
            `${process.env.REACT_APP_URL}/order`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setOrders(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false); // Set loading state to false after fetching
      }
    };
    fetchOrders();
  }, [token]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const openModal = (order) => {
    setSelectedOrder(order);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedOrder(null);
    setModalIsOpen(false);
  };

  useEffect(() => {
    Modal.setAppElement("#root"); // Set the root element of your application
  }, []);

  return (
    <div className="md:mt-28 mt-20 px-4">
      <div className="md:ml-20 font-sans font-medium text-2xl mb-4 text-center flex justify-between mx-2">
        <p>My Orders</p>
        <FaShoppingBag className="mt-1" />
      </div>

      {loading ? (
        // Loading skeletons
        Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="font-twentieth-century w-auto mx-auto bg-white rounded-lg border shadow-md md:ml-20 mb-4"
          >
            <div className="flex justify-between md:space-x-10 bg-slate-100 p-4 rounded-t-lg">
              <div className="flex flex-col">
                <Skeleton width={100} height={20} />
                <Skeleton width={100} height={20} />
              </div>
              <div className="hidden md:block">
                <Skeleton width={80} height={20} />
                <Skeleton width={80} height={20} />
              </div>
              <div className="hidden md:block">
                <Skeleton width={80} height={20} />
                <Skeleton width={80} height={20} />
              </div>
              <div className="hidden md:block">
                <Skeleton width={80} height={20} />
                <Skeleton width={80} height={20} />
              </div>
              <Skeleton width={100} height={40} />
            </div>
            <div className="flex items-center m-4 border rounded-md">
              <Skeleton width={96} height={96} />
              <div className="ml-4 flex-grow">
                <Skeleton width={200} height={20} />
                <Skeleton width={100} height={20} />
                <Skeleton width={150} height={20} />
              </div>
            </div>
          </div>
        ))
      ) : orders.length > 0 ? (
        orders.map((order, index) => (
          <div
            key={index}
            className="font-twentieth-century w-auto mx-auto bg-white rounded-lg border shadow-md md:ml-20 mb-4"
          >
            <div className="flex justify-between md:space-x-10 bg-slate-100 p-4 rounded-t-lg">
              <div className="flex flex-col">
                <p className="font-semibold text-md">Order Status</p>
                <p className="text-md text-green-500 font-light">
                  {order.orderStatus}
                </p>
              </div>
              <div className="hidden md:block">
                <span className="font-light text-sm text-gray-500">Total:</span>
                <span className="text-sm">₹{order.orderValue}</span>
              </div>
              <div className="hidden md:block">
                <p className="text-gray-600 text-sm">Payment Mode:</p>
                <p>{order.paymentType}</p>
              </div>
              <div className="hidden md:block">
                <p className="text-gray-600 text-sm">Placed On:</p>
                <p>{formatDate(order.createdAt)}</p>
              </div>
              <button
                onClick={() => openModal(order)}
                className="bg-red-50 text-red-500 px-4 py-2 rounded-md shadow hover:bg-red-100"
              >
                View Details
              </button>
            </div>
            {order.item.map((product, prodIndex) => (
              <div
                className="flex items-center m-4 border rounded-md"
                key={prodIndex}
              >
                <img
                  src={`${process.env.REACT_APP_URL}/${product.productId.images[0]}`}
                  alt={product.productId.name}
                  className="w-24 h-24 object-cover rounded-md"
                />
                <div className="ml-4 flex-grow">
                  <div className="flex justify-between items-center">
                    <h4 className="text-lg font-medium">
                      {product.productId.name}
                    </h4>
                    <p className="text-gray-600 px-2 mt-1">
                      Price: ₹{product.productId.price}
                    </p>
                  </div>
                  <p className="text-gray-600">
                    Color: {product.productId.color}
                  </p>
                  <p className="text-gray-600">
                    Size: {product.size} | Quantity: {product.quantity}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ))
      ) : (
        <p className="text-center text-gray-600">No orders found.</p>
      )}

      {/* Order Details Modal */}
      <OrderDetails
        isOpen={modalIsOpen}
        onClose={closeModal}
        order={selectedOrder}
      />
    </div>
  );
};

export default AllOrders;
